import type {PaymentExpandedCommon} from '../../../../api/payment';
import type {AvailableAmountToRefund} from './types';

import {currentUserStore} from '../../../../api/user';
import {not} from '../../../../utils/conditionalUtils';
import {isPaymentFailed} from '../../../../utils/entity/payment';

export const MAKE_REFUND_SUCCESS_EVENT = 'payment:make_refund_success';

export const MAKE_REFUND_FAIL_EVENT = 'payment:make_refund_fail';

export const getAvailableAmountToRefund = (
  payment: PaymentExpandedCommon,
): AvailableAmountToRefund => {
  const {user} = currentUserStore;

  if (!user) {
    return {
      byCard: 0,
      byStripe: 0,
    };
  }

  let amountByCard = 0;
  let amountByStripe = 0;

  // pay attention that if we call this function from a client side
  // we will not have the transfer by user._id
  const transfer = payment.transfers[user._id];

  // via Stripe we can refund only the amount that was transferred to the coach
  const totalAmountForStripe = transfer?.amount || 0;

  // by card we can refund honestly any amount
  // but let's limit it to the amount that a client paid
  const totalAmountForCard = payment.amount;

  payment.refunds.forEach(refund => {
    if (!refund) {
      return;
    }

    if (refund.refund_payment_id) {
      // take into account not failed payments only
      if (not(isPaymentFailed(refund.refundPayment))) {
        amountByCard += refund.amount;
      }
    } else if (refund.status !== 'failed') {
      amountByStripe += refund.amount;
    }
  });

  return {
    byCard: Math.max(totalAmountForCard - amountByCard - amountByStripe, 0),
    byStripe: Math.max(totalAmountForStripe - amountByStripe - amountByCard, 0),
  };
};
